import { Link, type LinkProps } from 'react-router';
import { useTenantPath } from '@/lib/auth/TenantCodeContext';

export function TenantLink({ to, ...props }: LinkProps) {
  const resolved = useTenantPath(typeof to === 'string' ? to : to.pathname ?? '');
  const resolvedTo = typeof to === 'string' ? resolved : { ...to, pathname: resolved };
  return <Link {...props} to={resolvedTo} />;
}
